import { useEffect, useState } from "react";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { ArrowRight } from "lucide-react";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // Section G: /admin/login must not be indexed by search engines either.
  useEffect(() => {
    const prev = document.head.querySelector('meta[name="robots"]');
    const prevContent = prev ? prev.getAttribute("content") : null;
    let el = prev;
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute("name", "robots");
      document.head.appendChild(el);
    }
    el.setAttribute("content", "noindex, nofollow");
    return () => {
      if (prevContent != null) el.setAttribute("content", prevContent);
      else el.remove();
    };
  }, []);

  if (user && user !== false) {
    const to = loc.state?.from || "/admin";
    return <Navigate to={to} replace />;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await login(email, password);
      nav("/admin", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-[#F6F0E7] flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-12">
          <p className="overline">Back-office</p>
          <h1 className="font-display text-5xl mt-4 text-[#203240]">L'Entracte</h1>
          <p className="mt-3 text-[#697585] text-sm">Espace administration</p>
        </div>

        <form onSubmit={onSubmit} className="space-y-6 border border-[#D9D3C5] bg-[#FFFFFF] p-8 md:p-10" data-testid="admin-login-form">
          <div>
            <label className="overline block mb-2">Email</label>
            <input data-testid="login-email" required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="field" autoComplete="email" />
          </div>
          <div>
            <label className="overline block mb-2">Mot de passe</label>
            <input data-testid="login-password" required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="field" autoComplete="current-password" />
          </div>
          {error && <p data-testid="login-error" className="text-sm text-red-400">{error}</p>}
          <button data-testid="login-submit" type="submit" disabled={loading} className="btn-primary w-full justify-center">
            {loading ? "Connexion…" : "Se connecter"} <ArrowRight size={14} />
          </button>
        </form>
      </div>
    </div>
  );
}
